import { getDatabase, set, ref, push, get } from 'firebase/database'
import app from '../Firebase';
import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 6)

// PUT calls
export const updateAssessmentStatus = async ({ assessmentId, deploymentId, status }) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/deployments/${deploymentId}/assessment/${assessmentId}`;

    console.log("asmtStatus apiUrl", apiUrl)
    console.log("asmtStatus assessmentId, deploymentId, status", assessmentId, deploymentId, status)

    if (!assessmentId || !deploymentId || !status) {
      throw new Error('Something is missing!');
    }

    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', },
      body: JSON.stringify({ status: status })
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();
    return result
  }
  catch (error) {
    console.error('Failed to fetch organisation details:', error.message);
  }
};

export const updateAssessmentProgress = async (assessmentId, progress_payload) => {
  console.log("progress_payload", progress_payload)
  try {
    if (!assessmentId) {
      throw new Error('Something is missing!');
    }
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/${assessmentId}/assessment-progress`;

    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', },
      body: JSON.stringify({ metas: progress_payload })
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();
    return result
  }
  catch (error) {
    console.error('Failed to update assessment Progress:', error.message);
  }
};


//GET calls
export const fetchAssessmentProgress = async (assessmentId) => {
  try {
    if (!assessmentId) {
      throw new Error('Something is missing!');
    }
    const apiUrl = `${process.env.REACT_APP_API_URI}/v5/organisations/tl/${assessmentId}/assessment-progress`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();
    return result
  }
  catch (error) {
    console.error('Failed to fetch assessment Progress:', error.message);
  }
};


// firebase

// types = self_complete, 360_complete, all_complete, asmt_reminder, client_added
// action = go_to_results, go_to_clients, send_reminder
export const sendNotifications = async ({ action, action_link, msg, user_name, type, orgId, asmtId, clientId }) => {
  const db = getDatabase(app);
  const dbRef = ref(db, `notifications/${process.env.REACT_APP_CLIENT_ID}`);

  try {
    // Fetch existing notifications
    const snapshot = await get(dbRef);

    if (snapshot.exists()) {
      const notifications = Object.values(snapshot.val() || {});
      const isDuplicate = notifications.some((n) => n.asmtId === asmtId);

      if (isDuplicate) {
        console.log("Duplicate notification.");
        return;
      }
    }

    const notificationsRef = push(dbRef);
    await set(notificationsRef, {
      id: `asmt-${nanoid()}`,
      action: action,
      action_link: action_link,
      message: msg,
      user_name: user_name,
      orgId: orgId,
      asmtId: asmtId,
      clientId: clientId,
      isRead : false,
      notification_type: type,
      reference_id: process.env.REACT_APP_CLIENT_ID,
      timestamp: new Date().toISOString()
    });

    console.log("Notification sent.");
  } catch (error) {
    console.error("Error sending notification:", error);
  }
};

